import React, { useState } from 'react';
import Login from './Login';
import Register from './Register';

interface AuthProps {
  onLoginSuccess: (token: string, user: any) => void;
}

const Auth: React.FC<AuthProps> = ({ onLoginSuccess }) => {
  const [isLogin, setIsLogin] = useState(true);

  const handleSwitchToRegister = () => setIsLogin(false);
  const handleSwitchToLogin = () => setIsLogin(true);
  const handleRegisterSuccess = () => {};

  return (
    <div>
      {isLogin ? (
        <Login 
          onSwitchToRegister={handleSwitchToRegister}
          onLoginSuccess={onLoginSuccess}
        />
      ) : (
        <Register 
          onSwitchToLogin={handleSwitchToLogin}
          onRegisterSuccess={handleRegisterSuccess}
        />
      )}
    </div>
  );
};

export default Auth; 